import { Link } from "react-router-dom";

function Navbar() {
  return (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      padding: "15px",
      background: "rgba(255,255,255,0.1)",
      backdropFilter: "blur(10px)"
    }}>
      <h2>PrepGrid 🚀</h2>

      <div>
        <Link to="/" style={link}>Home</Link>
        <Link to="/dashboard" style={link}>Dashboard</Link>
        <Link to="/practice" style={link}>Practice</Link>
        <Link to="/interview" style={link}>Interview</Link>
        <Link to="/leaderboard" style={link}>Leaderboard</Link>
      </div>
    </div>
  );
}

const link = {
  margin: "10px",
  color: "white",
  textDecoration: "none",
  fontWeight: "bold"
};

export default Navbar;